/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CustomDdl } from '../model/customDdl';
import { CustomDdlCreateRequest } from '../model/customDdlCreateRequest';
import { CustomDdlKeys } from '../model/customDdlKeys';
import { CustomDdlUpdateRequest } from '../model/customDdlUpdateRequest';
import { ErrorInformation } from '../model/errorInformation';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class CustomDDLService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createCustomDdl
     * Creates a new custom DDL. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param customDdlCreateRequest the information needed to create a custom DDL
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customDDLCreateCustomDdl(customDdlCreateRequest: CustomDdlCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<CustomDdl>;
    public customDDLCreateCustomDdl(customDdlCreateRequest: CustomDdlCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomDdl>>;
    public customDDLCreateCustomDdl(customDdlCreateRequest: CustomDdlCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomDdl>>;
    public customDDLCreateCustomDdl(customDdlCreateRequest: CustomDdlCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (customDdlCreateRequest === null || customDdlCreateRequest === undefined) {
            throw new Error('Required parameter customDdlCreateRequest was null or undefined when calling customDDLCreateCustomDdl.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CustomDdl>(`${this.configuration.basePath}/customDdls`,
            customDdlCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteCustomDdl
     * Deletes an existing custom DDL. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param namespace the namespace
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param businessObjectFormatVersion the business object format version
     * @param customDdlName the custom DDL name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customDDLDeleteCustomDdl(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, customDdlName: string, observe?: 'body', reportProgress?: boolean): Observable<CustomDdl>;
    public customDDLDeleteCustomDdl(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, customDdlName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomDdl>>;
    public customDDLDeleteCustomDdl(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, customDdlName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomDdl>>;
    public customDDLDeleteCustomDdl(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, customDdlName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling customDDLDeleteCustomDdl.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling customDDLDeleteCustomDdl.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling customDDLDeleteCustomDdl.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling customDDLDeleteCustomDdl.');
        }
        if (businessObjectFormatVersion === null || businessObjectFormatVersion === undefined) {
            throw new Error('Required parameter businessObjectFormatVersion was null or undefined when calling customDDLDeleteCustomDdl.');
        }
        if (customDdlName === null || customDdlName === undefined) {
            throw new Error('Required parameter customDdlName was null or undefined when calling customDDLDeleteCustomDdl.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<CustomDdl>(`${this.configuration.basePath}/customDdls/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}/businessObjectFormatVersions/${encodeURIComponent(String(businessObjectFormatVersion))}/customDdlNames/${encodeURIComponent(String(customDdlName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getCustomDdl
     * Gets an existing custom DDL. &lt;p&gt;Requires READ permission on namespace&lt;/p&gt;
     * @param namespace the namespace
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param businessObjectFormatVersion the business object format version
     * @param customDdlName the custom DDL name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customDDLGetCustomDdl(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, customDdlName: string, observe?: 'body', reportProgress?: boolean): Observable<CustomDdl>;
    public customDDLGetCustomDdl(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, customDdlName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomDdl>>;
    public customDDLGetCustomDdl(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, customDdlName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomDdl>>;
    public customDDLGetCustomDdl(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, customDdlName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling customDDLGetCustomDdl.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling customDDLGetCustomDdl.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling customDDLGetCustomDdl.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling customDDLGetCustomDdl.');
        }
        if (businessObjectFormatVersion === null || businessObjectFormatVersion === undefined) {
            throw new Error('Required parameter businessObjectFormatVersion was null or undefined when calling customDDLGetCustomDdl.');
        }
        if (customDdlName === null || customDdlName === undefined) {
            throw new Error('Required parameter customDdlName was null or undefined when calling customDDLGetCustomDdl.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<CustomDdl>(`${this.configuration.basePath}/customDdls/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}/businessObjectFormatVersions/${encodeURIComponent(String(businessObjectFormatVersion))}/customDdlNames/${encodeURIComponent(String(customDdlName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getCustomDdls
     * Gets a list of keys for all existing custom DDLs for a specific business object format. &lt;p&gt;Requires READ permission on namespace&lt;/p&gt;
     * @param namespace the namespace
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param businessObjectFormatVersion the business object format version
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customDDLGetCustomDdls(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, observe?: 'body', reportProgress?: boolean): Observable<CustomDdlKeys>;
    public customDDLGetCustomDdls(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomDdlKeys>>;
    public customDDLGetCustomDdls(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomDdlKeys>>;
    public customDDLGetCustomDdls(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling customDDLGetCustomDdls.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling customDDLGetCustomDdls.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling customDDLGetCustomDdls.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling customDDLGetCustomDdls.');
        }
        if (businessObjectFormatVersion === null || businessObjectFormatVersion === undefined) {
            throw new Error('Required parameter businessObjectFormatVersion was null or undefined when calling customDDLGetCustomDdls.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<CustomDdlKeys>(`${this.configuration.basePath}/customDdls/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}/businessObjectFormatVersions/${encodeURIComponent(String(businessObjectFormatVersion))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateCustomDdl
     * Updates an existing custom DDL. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param namespace the namespace
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param businessObjectFormatVersion the business object format version
     * @param customDdlName the custom DDL name
     * @param customDdlUpdateRequest the request information needed to update the custom DDL
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customDDLUpdateCustomDdl(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, customDdlName: string, customDdlUpdateRequest: CustomDdlUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<CustomDdl>;
    public customDDLUpdateCustomDdl(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, customDdlName: string, customDdlUpdateRequest: CustomDdlUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomDdl>>;
    public customDDLUpdateCustomDdl(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, customDdlName: string, customDdlUpdateRequest: CustomDdlUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomDdl>>;
    public customDDLUpdateCustomDdl(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, customDdlName: string, customDdlUpdateRequest: CustomDdlUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling customDDLUpdateCustomDdl.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling customDDLUpdateCustomDdl.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling customDDLUpdateCustomDdl.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling customDDLUpdateCustomDdl.');
        }
        if (businessObjectFormatVersion === null || businessObjectFormatVersion === undefined) {
            throw new Error('Required parameter businessObjectFormatVersion was null or undefined when calling customDDLUpdateCustomDdl.');
        }
        if (customDdlName === null || customDdlName === undefined) {
            throw new Error('Required parameter customDdlName was null or undefined when calling customDDLUpdateCustomDdl.');
        }
        if (customDdlUpdateRequest === null || customDdlUpdateRequest === undefined) {
            throw new Error('Required parameter customDdlUpdateRequest was null or undefined when calling customDDLUpdateCustomDdl.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<CustomDdl>(`${this.configuration.basePath}/customDdls/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}/businessObjectFormatVersions/${encodeURIComponent(String(businessObjectFormatVersion))}/customDdlNames/${encodeURIComponent(String(customDdlName))}`,
            customDdlUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
